const dateHandlerMixin = {
  data() {
    return {};
  },
  methods: {
    formatDate(dateStr, lang) {
      if (!dateStr) {
        return 'N/I';
      }

      const date = new Date(dateStr);
      let dia = date.getUTCDate();
      if (dia < 10) {
        dia = `0${dia}`;
      }
      let mes = date.getMonth() + 1;
      if (mes < 10) {
        mes = `0${mes}`;
      }

      if (lang === 'pt') {
        return `${dia}/${mes}/${date.getFullYear()}`;
      }

      return `${dia}-${mes}-${date.getUTCDate()}`;
    },
    formatDateComHora(data) {
      const dataFormatada = data ? new Date(data) : new Date();

      return dataFormatada.toLocaleDateString('pt-BR', {
        day: '2-digit',
        month: '2-digit',
        year: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        hour12: false,
      }).replace(',', '');
    },
  },
};

export default dateHandlerMixin;
